export const VIVRE_EN_VILLE_PATHS = {
  MAP: '/vivre-en-ville/map',
  RENTS: '/vivre-en-ville/rents',
  RENT: '/vivre-en-ville/rent'
} as const
